import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

/**
 * What the details side shows when nothing is selected.
 *
 * It used to be the screen's own icon, blown up to 100px and greyed out. The
 * customer did not read that as "nothing is selected" - they read it as a
 * strange picture, and asked what it was. An empty screen that has to be
 * explained is not doing its job, so it says so in words instead.
 *
 * The same block was written out eleven times, once per details screen, with
 * eleven copies of the same css. Two of those copies had already lost their
 * markup and styled nothing at all.
 */
@Component({
    selector: "empty-details",
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: "./empty-details.component.html",
    styleUrls: ["./empty-details.component.css"],
})
export class EmptyDetailsComponent {
    /**
     * A translation key naming what the list beside this holds, written as the
     * article and the noun together - "een ticket", "a ticket" - because the
     * article is not the same for every word and is not the same in every
     * language either.
     */
    /**
     * A translation key for the first line. The default covers the common case,
     * a details side with nothing chosen; a list that found nothing is a
     * different sentence and says so.
     */
    @Input() title = "empty.nothingSelected";

    @Input() what = "";

    /**
     * A translation key for the second line, for the screens where there is no
     * list to choose from - the one behind the menu, before anything at all is
     * picked. Used only when `what` is not given.
     */
    @Input() hint = "";
}
